import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { WMSSelect } from "../../widgets/selectbox";
import { WMSInput } from "../../widgets/input";
import { TableLineLoader } from "../../widgets/tableloader";
// import { taskColumn } from "../../widgets/tableColumn";
import "./submitarticle.scss";
import { toastError, toastSuccess, toastWarning } from "../../widgets/toaster";
import { apiUrl } from "../../base/utils";
import WHSLoader from "../../widgets/loader";
import { invokeDeleteService, invokeGetService, invokePostService } from "../../service";
import { dispatchStepAction,dispatchFileUpload } from "../../redux/action";
import CustomTable from "../table/customTable";
import { createColumnHelper } from "@tanstack/table-core";
import HOCAutoLogout from "../autologout";
import moment from "moment";

const columnHelper = createColumnHelper();
interface Row {
  getValue: () => any;
  row: any;
}

function MyTask(props: any) {
  const [isTableLoader] = useState(false);
  // const [columns, setColumns] = useState(taskColumn);
  const [tableData, setTableData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [selectfileterData, setselectfileterData] = useState([]);
  // const [pagination, setPagination] = useState({ startIndex: 0, endIndex: 5 });
  const [message, setMessageContent] = useState("");
  const [constentId, setContentId] = useState(0);
  const [stageDropdown, setStageDropdown] = useState([]);
  const [currentlyDropdown, setCurrentlyDropdown] = useState([]);
  const [pdfDownloadInProgress, setPdfDownloadInProgress] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState<any>(null);

  const [downloadInProgress, setDownloadInProgress] = useState<{ [key: string]: boolean }>({});

  const [stageValue, setStageValue] = useState({
    label: "All Status",
    value: "All Stages",
  });
  // const [statusValue, setStatusValue] = useState('All Status');
  const [currentlywithValue, setCurrentlyValue] = useState({
    label: "All Users",
    value: "Currently with All",
  });

  const [render, setRender] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [isMsgModal, setMsgModal] = useState(false);
  // const [recordpage, setRecordPage] = useState(5);
  const [isLoader, setLoader] = useState(false);

  const WS_URL: string = process.env.REACT_APP_WS_URL || "";

  useEffect(() => {
    const ws = new WebSocket(WS_URL);
  
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
  
      if (data.type === 'STAGE_UPDATED') {
        console.log('event.data', event.data);
        getJournalTitelList("table_list");
      }
    };
  
    return () => ws.close();
  }, []);

  const navigate = useNavigate();

  function truncateText(text: string, numWords: any) {
    const words = text.split(" ");
    const truncated = words.slice(0, numWords).join(" ");
    if (words.length > numWords) {
      return truncated.replace(/<[^>]*>/g, "");
    }
    return truncated.replace(/<[^>]*>/g, "");
  }
  const formatedDate = (dateString: string) => {
    const date = new Date(dateString);
    return moment(date).format('DD-MM-YYYY');
};

  const taskColumns = [
    columnHelper.accessor("serial", {
      header: "S.No",
    }),
    columnHelper.accessor("articlename", {
      header: "Article Id",
    }),
    columnHelper.accessor("articletitle", {
      header: "Article Title",
      cell: (row: Row) => {
        const item = row?.getValue() || "";
        const cleanedItem = item.replace(/<[^>]*>/g, "");
        const truncatedItem = truncateText(cleanedItem, 2);
        const displayItem =
          cleanedItem.length > truncatedItem.length
            ? truncatedItem + "..."
            : truncatedItem;
        return (
          <span className="visible" title={cleanedItem}>
            {displayItem}
          </span>
        );
      },
    }),
    columnHelper.accessor("journal", {
      header: "Journal",
      cell: (row: Row) => {
        const item = row?.getValue() || "";
        const hoverText = row?.row?.original?.journalname;
        return (
          <span className="visible" title={hoverText}>
            {item}
          </span>
        );
      },
    }),
    columnHelper.accessor("submitted_date", {
      header: "Submission Date",
      cell: (row: any) => {
        const value = row.getValue();
        const rowData = row.row.original;
        if (rowData.stage === "Submission pending" || rowData.stage === "Confirmation pending" || rowData.stage === "Failed") {
          return "-";
        }
        return formatedDate(value);
      }
    }),
    columnHelper.accessor("stage", {
      header: "Status",
      cell: (row: Row) => {
        const value = row.getValue();
        let className = "cellStyle";
        let displayValue = value;

        // Setting className and displayValue based on the value
        switch (value) {
          case "Submission pending":
            className += " yellowBadge";
            break;
          case "Manuscript submitted":
            className += " yellowBadge";
            break;
          case "Out to reviewers":
            className += " yellowBadge";
            break;
          case "Awaiting reviewer report":
            className += " yellowBadge";
            break;
          case "Awaiting decision":
            className += " yellowBadge";
            break;
          case "In revision":
            className += " yellowBadge";
            break;
          case "Revision: Manuscript submitted":
            className += " yellowBadge";
            displayValue = "Revision: Manuscript submitted";
            break;
          case "Revision: Out to reviewers":
            className += " yellowBadge";
            displayValue = "Revision: Out to reviewers";
            break;
          case "Revision: Awaiting reviewer report":
            className += " yellowBadge";
            displayValue = "Revision: Awaiting reviewer report";
            break;
          case "Revision: Awaiting decision":
            className += " yellowBadge";
            displayValue = "Revision: Awaiting decision";
            break;
          case "Production":
            className += " yellowBadge";
            break;
          case "Rejected":
            className += " failed";
            break;
          case "Move article to production":
            className += " greenbadge";
            break;
          case "Allocated":
              className += " greenbadge";
              break;
          case "Failed":
            className += " failed";
            break;
          case "Confirmation pending":
            className += " yellowBadge";
            displayValue = "Confirmation pending";
            break;
          case "Out to language editor":
            className += " yellowBadge";
            break;
          case "Awaiting conclusion":
            className += " yellowBadge";
            break;
          default:
            break;
        }

        return <span className={className}>{displayValue}</span>;
      },
    }),
    columnHelper.accessor("currentlywith", {
      header: "Currently With",
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (row: any) => {
        const rowData = row?.row?.original;
        const isPlay = rowData?.isplay === 1;
        const isDelete = rowData?.isdelete === 1;
        const isAuthorEnabled = rowData?.iauthorenable === 0;
        return (
          <div style={{ textAlign: "left" }}>
            <button
              className="iconBtn"
              onClick={() => iAuthorDetails(rowData)}
              disabled={
                rowData?.iauthorenable === 0 || rowData?.articleguid == null
              }
              style={{ border: "none", background: "none" }}
              title="iAuthor"
            >
              <span className="ia-btn f-20" title="iAuthor">
                iA
              </span>
            </button>
            {/* <button
              className="iconBtn f-20"
              onClick={() => pdfDetails(rowData)}
              disabled={!rowData?.html}
              style={{ border: "none", background: "none" }}
              title="Technical Report"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9091 15.7455C10.9091 15.9191 10.8401 16.0855 10.7174 16.2083C10.5946 16.331 10.4281 16.4 10.2545 16.4H9.16364V21.8545C9.16364 22.0281 9.09468 22.1946 8.97192 22.3174C8.84917 22.4401 8.68269 22.5091 8.50909 22.5091C8.33549 22.5091 8.16901 22.4401 8.04626 22.3174C7.92351 22.1946 7.85455 22.0281 7.85455 21.8545V16.4H6.76364C6.59004 16.4 6.42355 16.331 6.3008 16.2083C6.17805 16.0855 6.10909 15.9191 6.10909 15.7455C6.10909 15.5719 6.17805 15.4054 6.3008 15.2826C6.42355 15.1599 6.59004 15.0909 6.76364 15.0909H10.2545C10.4281 15.0909 10.5946 15.1599 10.7174 15.2826C10.8401 15.4054 10.9091 15.5719 10.9091 15.7455ZM4.14545 15.0909C3.97186 15.0909 3.80537 15.1599 3.68262 15.2826C3.55987 15.4054 3.49091 15.5719 3.49091 15.7455V18.1455H1.30909V15.7455C1.30909 15.5719 1.24013 15.4054 1.11738 15.2826C0.994628 15.1599 0.828142 15.0909 0.654545 15.0909C0.480949 15.0909 0.314463 15.1599 0.191712 15.2826C0.0689608 15.4054 0 15.5719 0 15.7455V21.8545C0 22.0281 0.0689608 22.1946 0.191712 22.3174C0.314463 22.4401 0.480949 22.5091 0.654545 22.5091C0.828142 22.5091 0.994628 22.4401 1.11738 22.3174C1.24013 22.1946 1.30909 22.0281 1.30909 21.8545V19.4545H3.49091V21.8545C3.49091 22.0281 3.55987 22.1946 3.68262 22.3174C3.80537 22.4401 3.97186 22.5091 4.14545 22.5091C4.31905 22.5091 4.48554 22.4401 4.60829 22.3174C4.73104 22.1946 4.8 22.0281 4.8 21.8545V15.7455C4.8 15.5719 4.73104 15.4054 4.60829 15.2826C4.48554 15.1599 4.31905 15.0909 4.14545 15.0909ZM23.3455 21.2H21.8182V15.7455C21.8182 15.5719 21.7492 15.4054 21.6265 15.2826C21.5037 15.1599 21.3372 15.0909 21.1636 15.0909C20.99 15.0909 20.8236 15.1599 20.7008 15.2826C20.5781 15.4054 20.5091 15.5719 20.5091 15.7455V21.8545C20.5091 22.0281 20.5781 22.1946 20.7008 22.3174C20.8236 22.4401 20.99 22.5091 21.1636 22.5091H23.3455C23.5191 22.5091 23.6855 22.4401 23.8083 22.3174C23.931 22.1946 24 22.0281 24 21.8545C24 21.681 23.931 21.5145 23.8083 21.3917C23.6855 21.269 23.5191 21.2 23.3455 21.2ZM18.2836 15.1149C18.1457 15.0766 17.999 15.0845 17.866 15.1375C17.733 15.1905 17.621 15.2856 17.5473 15.4084L15.4909 18.8371L13.4345 15.4084C13.361 15.2853 13.2491 15.1898 13.116 15.1366C12.9829 15.0833 12.8361 15.0752 12.6979 15.1134C12.5598 15.1517 12.438 15.2343 12.3514 15.3485C12.2647 15.4626 12.2179 15.6021 12.2182 15.7455V21.8545C12.2182 22.0281 12.2871 22.1946 12.4099 22.3174C12.5326 22.4401 12.6991 22.5091 12.8727 22.5091C13.0463 22.5091 13.2128 22.4401 13.3356 22.3174C13.4583 22.1946 13.5273 22.0281 13.5273 21.8545V18.1084L14.9291 20.4462C14.9872 20.5434 15.0695 20.6238 15.1679 20.6797C15.2664 20.7355 15.3777 20.7649 15.4909 20.7649C15.6041 20.7649 15.7154 20.7355 15.8139 20.6797C15.9123 20.6238 15.9946 20.5434 16.0527 20.4462L17.4545 18.1084V21.8545C17.4545 22.0281 17.5235 22.1946 17.6463 22.3174C17.769 22.4401 17.9355 22.5091 18.1091 22.5091C18.2827 22.5091 18.4492 22.4401 18.5719 22.3174C18.6947 22.1946 18.7636 22.0281 18.7636 21.8545V15.7455C18.7636 15.6023 18.7166 15.4632 18.6299 15.3493C18.5432 15.2354 18.4216 15.1531 18.2836 15.1149ZM20.5091 11.3818C20.5091 11.5554 20.4401 11.7219 20.3174 11.8447C20.1946 11.9674 20.0281 12.0364 19.8545 12.0364C19.681 12.0364 19.5145 11.9674 19.3917 11.8447C19.269 11.7219 19.2 11.5554 19.2 11.3818V9.41818H13.7455C13.5719 9.41818 13.4054 9.34922 13.2826 9.22647C13.1599 9.10372 13.0909 8.93723 13.0909 8.76364V3.30909H3.27273C3.21486 3.30909 3.15937 3.33208 3.11845 3.37299C3.07753 3.41391 3.05455 3.46941 3.05455 3.52727V11.3818C3.05455 11.5554 2.98558 11.7219 2.86283 11.8447C2.74008 11.9674 2.5736 12.0364 2.4 12.0364C2.2264 12.0364 2.05992 11.9674 1.93717 11.8447C1.81442 11.7219 1.74545 11.5554 1.74545 11.3818V3.52727C1.74545 3.12222 1.90636 2.73375 2.19278 2.44733C2.4792 2.16091 2.86767 2 3.27273 2H13.7455C13.8316 1.99993 13.9168 2.01686 13.9964 2.0498C14.076 2.08275 14.1482 2.13107 14.2091 2.192L20.3182 8.30109C20.4406 8.4239 20.5092 8.59026 20.5091 8.76364V11.3818ZM18.2749 8.10909L14.4 4.23418V8.10909H18.2749Z"
                  fill="black"
                />
              </svg>
            </button> */}
            <button
            className="iconBtn"
            onClick={() => handlepdf(rowData)}
            id="info_btn"
            disabled={downloadInProgress[rowData.articleguid] || rowData?.isauthorpdfennabled || rowData?.stage == 'Failed'}
            style={{ border: 'none', background: 'none' }}
            title="Manuscript PDF"
            aria-label="Download Manuscript PDF"
          >
            {downloadInProgress[rowData.articleguid] ? (
              // Show loader spinner when download is in progress
              <div className="loader"></div>
            ) : (
              // Show PDF icon when download is not in progress
              <span className="material-icons f-20">picture_as_pdf</span>
            )}

            {downloadInProgress[rowData.articleguid] && <span className="yellowBadge"></span>}
          </button>
            {isPlay && isAuthorEnabled && (
              <button
                className="iconBtn"
                onClick={() => subMissionDetails(rowData)}
                title="Resume Manuscript Summary"
                //  disabled={!isPlay || !isAuthorEnabled}
              >
                <i className="bi bi-play"></i>
              </button>
            )}
            { isDelete && (
              <button
                className="iconBtn"
                onClick={() => handleDeleteClick(rowData)}
                style={{ border: "none", background: "none" }}
                title="Delete Article"
              >
                <span className="material-icons f-20 text-danger">delete</span>
              </button>
          )} 
          </div>
        );
      },
    }),
  ];

  const handlepdf = async (item: any) => {
    try {
      const rowId = item.articleguid;
      setDownloadInProgress((prevState) => ({
        ...prevState,
        [rowId]: true,
      }));
  
      let url = apiUrl.nodeApi.getPdfLinkByActivity;
      const payload = {
        activityid: item.lastactivityid,
        article_guid: item.articleguid,
      };
  
      setLoader(true);
  
      const timer = setTimeout(() => {
        setLoader(false);
        toastWarning("Download in progress, Please wait for few Minutes.");
      }, 2000);
  
      const response: any = await invokePostService(url, payload, props.isToken);
  
      clearTimeout(timer);
  
      setLoader(false);
      setDownloadInProgress((prevState) => ({
        ...prevState,
        [rowId]: false,
      }));
  
      if (!response.data.isSuccess) {
        throw new Error(response.data.Error);
      }
  
      if (response.data.isSuccess) {
        const newWindow = window.open(response.data.result.downloadUrl, '_blank');
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          toastWarning("Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'.");
        }
      }
    } catch (error) {
      setLoader(false);
      setDownloadInProgress((prevState) => ({
        ...prevState,
        [item.articleguid]: false,
      }));
      toastWarning("The requested PDF is not available yet. Please try again after a few minutes.");
    }
  };

  const handleDeleteClick = (article: any) => {
    setSelectedArticle(article);
    setShowDeleteModal(true);
  };
  
  const handleDeleteConfirm = async () => {
    try {
      setLoader(true);
      const url = apiUrl.nodeApi.deleteArticleById;
      const payload = {
        articleId: selectedArticle.articleid
      };
      
      const response: any = await invokeDeleteService(url, payload, props.isToken);
      if (response?.data?.data?.isSuccess) {
        toastSuccess("Article deleted successfully");
        getJournalTitelList("table_list"); 
      } else {
        throw new Error(response.data.Error);
      }
    } catch (error) {
      toastError(`Failed to delete article: ${error}`);
    } finally {
      setLoader(false);
      setShowDeleteModal(false);
    }
  };

  const filterTableData = (journalOption: any, authorOption: any) => {
    const journalValue = journalOption.value
      ? journalOption.value.toLowerCase()
      : "";
    const authorValue = authorOption.value
      ? authorOption.value.toLowerCase()
      : "";
    let filteredData: any;

    if (journalValue !== "all stages" && authorValue !== "currently with all") {
      filteredData = initialData.filter(
        (list: any) =>
          list.stage.toLowerCase() === journalValue &&
          list.currentlywith.toLowerCase() === authorValue
      );
     
    } else if (journalValue !== "all stages") {
      filteredData = initialData.filter(
        (list: any) => list.stage.toLowerCase() === journalValue
      );
    } else if (authorValue !== "currently with all") {
      filteredData = initialData.filter(
        (list: any) => list.currentlywith.toLowerCase() === authorValue
      );
    } else {
      filteredData = initialData;
    }

    if (filteredData) {
      const updatedData = filteredData.map((list: any, i: any) => {
        return { ...list, serial: i + 1 };
      });
      setselectfileterData(updatedData);
      setTableData(updatedData);
    }
  };

  useEffect(() => {
    getJournalTitelList("table_list");
    getStagesList("stages");
    getUserRole("roles");
  }, []);

  const getJournalTitelList = async (type: any) => {
    try {
      setLoader(true);
      let url = apiUrl.nodeApi.getSubmitArticleList;
      let payload = {
        currentlyWith: [],
        stageId: [],
      };
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);

      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);

      // I am Filtering out duplicates based on articleid
      const uniqueResults = response.data.data.result.reduce(
        (acc: any[], current: any) => {
          const x = acc.find((item) => item.articleid === current.articleid);
          if (!x) {
            acc.push(current);
          }
          return acc;
        },
        []
      );

      // Adding the serial numbers
      uniqueResults.forEach((list: any, i: any) => {
        list.serial = i + 1;
      });

      // console.log(uniqueResults);
      setTableData(uniqueResults);
      setInitialData(uniqueResults);
    } catch (error) {
      toastError(`Get Article List ${error}`);
      setLoader(false);
    }
  };

  const getUserRole = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getUserRoles;
      // const response = await axios.get(`${config.prapp.basURL}${url}`);
      const response: any = await invokeGetService(url, {}, {}, props.isToken);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      response.data.data.result.unshift({
        label: "All Users",
        value: "Currently with All",
        id: "0",
      });
      setCurrentlyDropdown(response.data.data.result);
    } catch (error) {}
  };

  const getStagesList = async (type: any) => {
    try {
      let url = apiUrl.nodeApi.getStagesList;
      // const response = await axios.get(`${config.prapp.basURL}${url}`, {
      //     headers: {
      //         'authorization': `Bearer ${props.isToken}`,
      //         'Content-Type': 'application/json',
      //     },
      // });
      const response: any = await invokeGetService(url, {}, {}, props.isToken);
      if (!response.data.data.isSuccess)
        throw new Error(response.data.data.Error);
      response.data.data.result.unshift({
        label: "All Status",
        value: "All Stages",
        id: "0",
      });
      setStageDropdown(response.data.data.result);
    } catch (error) {
      // toastError(`Get journal title list option error ${error}`)
    }
  };
const applyCombinedFilters = (
  journalOption = stageValue,
  authorOption = currentlywithValue,
  searchTerm = searchData
) => {
  const journalValue = journalOption?.value?.toLowerCase() || "";
  const authorValue = authorOption?.value?.toLowerCase() || "";
  const search = searchTerm.toLowerCase();

  let filtered = [...initialData];

  if (journalValue && journalValue !== "all stages") {
    filtered = filtered.filter(
      (row:any) => row.stage?.toLowerCase() === journalValue
    );
  }

  if (authorValue && authorValue !== "currently with all" && authorValue !== "all users") {
    filtered = filtered.filter(
      (row:any) => row.currentlywith?.toLowerCase() === authorValue
    );
  }

  if (search.trim()) {
    filtered = filtered.filter((row: any) =>
      Object.values(row).some(
        (value: any) =>
          value &&
          value.toString().toLowerCase().includes(search)
      )
    );
  }

  const updatedData:any = filtered.map((item:any, i) => ({ ...item, serial: i + 1 }));
  setTableData(updatedData);
  setselectfileterData(updatedData); // store intermediate filtered data
};

const handleSearch = (e: any) => {
  const value = e.target.value.toLowerCase();
  setSearchData(value);
  applyCombinedFilters(stageValue, currentlywithValue, value);
};


const handleMultiSelection = (e: any, type: any) => {
  let updatedStage = stageValue;
  let updatedUser = currentlywithValue;

  if (type === "stage") {
    updatedStage = { label: e.label, value: e.value };
    setStageValue(updatedStage);
  } else {
    updatedUser = { label: e.label, value: e.value };
    setCurrentlyValue(updatedUser);
  }

  // Apply filter with updated dropdowns + current search term
  applyCombinedFilters(updatedStage, updatedUser, searchData);
};

  const iAuthorDetails = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.getLinkByGuid;
      const payload = {
        ActivityId: item.iauthoratyid,
        articleId: item.articleid,
        JobID: item.articleguid,
      };
      setLoader(true);
      const response: any = await invokePostService(
        url,
        payload,
        props.isToken
      );
      setLoader(false);
  
      if (!response.data.isSuccess) throw new Error(response.data.Error);
      if (response.data.isSuccess) {
        const newWindow = window.open(response.data.result, '_blank');
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          toastWarning("Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'.");
        }
      }
    } catch (error:any) {
      setLoader(false);
  
      if (error.message === '[object Object]') {
        getJournalTitelList("table_list");
        toastSuccess("Status updated successfully! Click again to proceed");
      } else {
        toastError(`${error}`);
      }
    }
  };
  
  

  // const subMissionDetails = async (item: any) => {
  //   props.dispatchStepAction("1");
  //   let fileUploaddata = {
  //     journalid: item.journalid,
  //     articletype: 0,
  //     filename: item.articlename,
  //     articleid: item.articleid,
  //     journaltitle: item.journalname
  // }
  // props.dispatchFileUpload(fileUploaddata);
  //   navigate("/createnewarticle", { state: { data: item } });
  // };

  const subMissionDetails = async (item: any) => {
    const stepValue = item.stage === "Failed" ? "0" : "1";
    props.dispatchStepAction(stepValue);
    
    let fileUploaddata = {
      journalid: item.journalid,
      articletype: 0,
      filename: item.articlename,
      articleid: item.articleid,
      journaltitle: item.journalname,
      
      isRetryAfterFailure: item.stage === "Failed"
    }
    
    props.dispatchFileUpload(fileUploaddata);

    navigate("/createnewarticle", { 
      state: { 
        data: item,
        isRetryAfterFailure: item.stage === "Failed"
      } 
    });
  };

  const pdfDetails = async (item: any) => {
    try {
      let url = apiUrl.nodeApi.getArticleReportDownloadUrl;
      const queryParams = { articleId: item.articleid };
      setLoader(true);
      const response: any = await invokeGetService(
        url,
        {},
        queryParams,
        props.isToken
      );
      setLoader(false);
  
      if (!response.data.isSuccess) throw new Error(response.data.Error);
  
      if (response.data.isSuccess) {
        const newWindow = window.open(response.data.result.downloadUrl, '_blank');
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          toastWarning("Browser blocked pop-ups. Click the pop-up blocker icon in the address bar and choose 'Allow pop-ups for this site'.");
        }
      }
    } catch (error) {
      toastError(`${error}`);
      setLoader(false);
    }
  };
  

  const handleModalClose = () => {
    setMsgModal(!isMsgModal);
  };
  const handleMsgSubmit = () => {};
  const handleMessageBox = (e: any, type: any) => {
    setMessageContent(e.target.value);
  };
const refreshTable = () => {
  const resetStage = { label: "All Status", value: "all stages" };
  const resetUser = { label: "All Users", value: "currently with all" };

  setStageValue(resetStage);
  setCurrentlyValue(resetUser);
  setSearchData("");
  setselectfileterData(initialData);

  const refreshed:any = initialData.map((item:any, i) => ({ ...item, serial: i + 1 }));
  setTableData(refreshed);
  getJournalTitelList("table_list");
};

  const addFileUpload = () => {
    props.dispatchStepAction("0");
    navigate("/createnewarticle");
  };
  return (
    <>
      {isLoader && <WHSLoader></WHSLoader>}
      <Modal show={isMsgModal} centered onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Send Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 form-group">
              <label className="col-form-label">
                Message <span className="error"> *</span>
              </label>
              <textarea
                maxLength={1000}
                placeholder={"Write message"}
                value={message}
                name="comments"
                className="form-control"
                onChange={(e: any) => handleMessageBox(e, "reason")}
                id="comments"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="messageBox d-flex">
          <Button onClick={handleMsgSubmit}>SAVE</Button>
          <Button
            className="ml-3"
            variant="outline-secondary"
            onClick={handleModalClose}
          >
            CANCEL
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="page-title">
        <h3>Manuscript Summary</h3>
        {/* props.userInfo.roles.filter((list:any) => list.roleid == 1).length > 0 ? (     */}
        <Button className="btn" onClick={() => addFileUpload()}>
          Submit New Article
        </Button>
      </div>
      <div className="mb-5">
        <div className="table-filter">
          <div className="row justify-content-between">
            <div className="col-lg-4 search-input">
              <WMSInput
                type="text"
                placeHolder="Search by Article ID, Article Title and Journal..."
                className="form-control"
                value={searchData}
                onChange={(e: any) => handleSearch(e)}
                id="search-table"
              />
              <span className="material-icons">search</span>
            </div>
            <div className="d-flex col-lg-8 table-dropdown-filter">
              <div className="d-flex">
                <label>Filter by</label>
                <div className="table-dropdown-filter-inner">
                  <WMSSelect
                    className="form-control"
                    placeHolder="Select..."
                    options={currentlyDropdown}
                    name="fileTypes"
                    value={currentlywithValue}
                    isMulti={false}
                    onChange={(e: any) =>
                      handleMultiSelection(e, "currentlywith")
                    }
                    id="fileTypes"
                  />
                  <WMSSelect
                    className="form-control"
                    placeHolder="Select..."
                    options={stageDropdown}
                    name="fileTypes"
                    value={stageValue}
                    isMulti={false}
                    onChange={(e: any) => handleMultiSelection(e, "stage")}
                    id="fileTypes"
                  />
                  <Button
                    className="btn btn-primary refresh-btn"
                    onClick={() => refreshTable()}
                  >
                    <span className="material-icons">refresh</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {isTableLoader ? (
            <TableLineLoader />
          ) : (
            <>
              {/* <WMSSimpleTable
                isTableLoader={isTableLoader}
                columns={columns}
                tableData={tableData}
                isPagination={true}
                pageValue={pagination}
                recordPerpage={recordpage}
                iAuthorDetails={(item: any) => iAuthorDetails(item)} //this is for iauthor link button
                pdfDetails={(item: any) => pdfDetails(item)} //this is for pdf details
                subMissionDetails={(item: any) => subMissionDetails(item)} // this is for submission detail popup
              /> */}
              <CustomTable
                columns={taskColumns}
                data={tableData}
                showPagination={true}
                isSearchable={false}
              />
            </>
          )}
        </div>
      </div>
      <Modal show={showDeleteModal} centered onHide={() => setShowDeleteModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="alert alert-warning">
      Warning: This action cannot be undone. The article will be permanently deleted.
    </div>
    <p>Do you want to proceed?</p>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={handleDeleteConfirm}>
      Delete
    </Button>
    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
      Cancel
    </Button>
  </Modal.Footer>
</Modal>
    </>
  );
}
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.rootReducer.authReducer.isLoggedIn,
    isToken: state.rootReducer.authReducer.token,
    userInfo: state.rootReducer.authReducer.userInfo,

  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    dispatchStepAction: (stepCounter: any) => {
      dispatchStepAction(dispatch, stepCounter);
    },
    dispatchFileUpload: (fileUploaddata: any) => {
      dispatchFileUpload(dispatch, fileUploaddata);
  },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HOCAutoLogout(MyTask));